import { PDFDocument } from "pdf-lib";

function base64ToUint8Array(base64String: string): Uint8Array {
  // Decode base64 to binary string
  const binaryString = atob(base64String);

  // Create Uint8Array from binary string
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes;
}

export const generateMergedPDF = async (pdfUrls: string[]) => {
  const hash = [...pdfUrls].sort().join("_");

  try {
    // 1. Fetch all PDFs in parallel as binary data
    const pdfByteArrays = await Promise.all(
      pdfUrls.map((url) => fetch(url).then((res) => res.arrayBuffer())),
    );
    // 2. Load each PDF into a PDFDocument
    const pdfDocs = await Promise.all(
      pdfByteArrays.map((bytes) => PDFDocument.load(bytes)),
    );
    // 3. Create a new PDFDocument for the merged output
    const mergedPdf = await PDFDocument.create();
    // 4. Copy pages from each PDF into the merged document in order
    for (const pdfDoc of pdfDocs) {
      const copiedPages = await mergedPdf.copyPages(
        pdfDoc,
        pdfDoc.getPageIndices(),
      );

      for (const page of copiedPages) {
        mergedPdf.addPage(page);
      }
    }
    // 5. Save the merged PDF as a Base64 string
    const mergedBase64 = await mergedPdf.saveAsBase64();

    const blob = new Blob([base64ToUint8Array(mergedBase64)], {
      type: "application/pdf",
    });

    return {
      hash,
      base64: mergedBase64,
      url: URL.createObjectURL(blob),
    };
  } catch (err) {
    console.error("PDF merge failed", err);
    return null;
  }
};
